"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaystePricingZoneSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.WaystePricingZoneSchema = {
    name: 'wayste-pricing-zone',
    alias: 'Wayste Pricing Zone',
    shortName: 'Pricing Zone',
    applications: ['wayste'],
    returnType: {
        wayste: transport_types_1.Pricing.PricingZone,
    },
    // No need to sync sourgum pricing in wayste as it is always connected to the same pricing zone
    filterDocuments: (documents) => documents.type === 'HAULER_BILLING',
    searchableAttributes: [
        {
            field: 'zoneName',
            alias: 'Zone Name',
            shortName: 'Zone',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            type: 'BOOLEAN',
            field: 'haulerApproved',
            alias: 'Approved',
            shortName: 'Approved',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        {
            type: 'BOOLEAN',
            field: 'sourgumApproved',
            alias: 'Sourgum Approved',
            shortName: 'Sourgum Approved',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        {
            type: 'STRING',
            field: 'state',
            alias: 'State',
            shortName: 'State',
            allowsMultipleValues: false,
            allowedOperators: 'ALL',
            options: transport_types_1.Pricing.USStateAbbreviations.map((state) => ({
                value: state,
                label: state,
            })),
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=wayste-pricing-zone.js.map